module.exports = __webpack_public_path__ + "70476a8825f148c0986ef6b6a22237f0.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1083
// module chunks = 0